// BLOCKED-ROWS (2026-07-18): the semantic domain action for unlocking a
// blocked sub row in place with an entered pin (show OR edit pin; for a
// time-blocked row the server accepts the EDIT pin only — the edit password
// overrides the time window, legacy get_locked parity).
//
// React notice-slot pin form -> dispatchSubUnlock -> facade.unlockSub
// (legacy-owned ajax_obj/get_locked/reimport_data_el orchestration + the
// per-place entered-pin memory) -> projection re-sync. The pin rides the
// POST body of the model request, never a URL (LOCKED-SCREEN rule).

import { getMsgDeskRuntime } from './runtime/MsgDeskRuntime'
import { syncCurrentLegacyProjection } from './state/projectionSync'

export interface SubUnlockRequest {
  elId: number
  pin: string
  isTimeLocked?: boolean
}

/** Resolves true when the row was unlocked and re-projected; false on a
 * refused pin or when the runtime is not ready yet. */
export async function dispatchSubUnlock(request: SubUnlockRequest): Promise<boolean> {
  const pin = String(request.pin ?? '').trim()
  if (!pin || !(request.elId > 0)) return false

  let runtime
  try {
    runtime = getMsgDeskRuntime()
  } catch {
    return false
  }
  if (!runtime?.facade) return false

  const unlocked = await runtime.facade.unlockSub(request.elId, pin, request.isTimeLocked === true)
  if (unlocked) syncCurrentLegacyProjection('sub-unlock')
  return unlocked
}
